import { render } from "./MenuConnected.vue?vue&type=template&id=7fba0bc7&scoped=true&ts=true"
import script from "./MenuConnected.vue?vue&type=script&lang=ts"
export * from "./MenuConnected.vue?vue&type=script&lang=ts"

import "./MenuConnected.vue?vue&type=style&index=0&id=7fba0bc7&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fba0bc7"]])

export default __exports__